import { createLogic } from 'redux-logic';
import { get, keys, map, pick, pickBy, identity } from 'lodash';
import { decorateRecipes } from 'decorators';

// Action Types
const CANCEL = '@@app/search/CANCEL';
const FETCH = '@@app/search/FETCH';
const FETCH_SUCCESS = '@@app/search/FETCH_SUCCESS';
const FETCH_ERROR = '@@app/search/FETCH_ERROR';
const RESET = '@@app/search/RESET';
const UPDATE_PARAM = '@@app/search/UPDATE_PARAM';
const UPDATE_PARAM_ERROR = '@@app/search/UPDATE_PARAM_ERROR';
const UPDATE_APPEND = '@@app/search/UPDATE_APPEND';

// Initial State
const initialState = {
  loading: false,
  append: false,
  message: '',
  results: [],
  pagination: {},
  params: {
    filters: '',
    level: '1',
    order: '',
    q: '',
    page: '1',
    serves: '',
  },
};

// Observables
const fetchLogic = createLogic({
  type: FETCH,
  cancelType: CANCEL,
  processOptions: {
    successType: FETCH_SUCCESS,
    failType: FETCH_ERROR,
  },
  process({ action, httpClient }) {
    const { endpoint, key, params } = action.payload;

    return httpClient.get(endpoint, { params }).then(response => {
      let data = response.data[key];

      if (key === 'recipes') {
        data = data.map(addRecipeVariations);
        data = decorateRecipes(data);
      }

      return { ...response, data };
    });
  },
});

const validateParamLogic = createLogic({
  type: UPDATE_PARAM,
  validate({ action }, allow, reject) {
    if (initialState.params[action.payload.key]) {
      allow(action);
    } else {
      reject({ type: UPDATE_PARAM_ERROR, error: true });
    }
  },
});

export const searchLogic = [fetchLogic, validateParamLogic];

// Selectors
export const selectSearchResults = state => {
  return state.results;
};

export const selectSearchPagination = state => {
  return state.pagination;
};

export const selectSearchParams = state => {
  return state.params;
};

// Helpers
export const parseAllowedParams = (params = {}) => {
  return parseParams(pick(params, keys(initialState.params)));
};

export const parseParams = (params = {}) => {
  return pickBy(params, identity);
};

// Action Creators
export const searchRecipes = (params = {}) => {
  return {
    type: FETCH,
    payload: {
      endpoint: `/v1/voome/recipe-collections/master`,
      key: 'recipes',
      params: parseAllowedParams(params),
    },
  };
};

export const searchWorkouts = (params = {}) => {
  return {
    type: FETCH,
    payload: {
      endpoint: '/v1/voome/workout-collections/master',
      key: 'workouts',
      params: parseAllowedParams(params),
    },
  };
};

export const resetSearch = () => {
  return { type: RESET };
};

export const searchAppend = payload => {
  return { type: UPDATE_APPEND, payload };
};

export const updateParam = (key, value) => {
  return {
    type: UPDATE_PARAM,
    payload: { key, value: String(value) },
  };
};

// Helpers
// The API will return this at some point
// https://redant.jira.com/browse/MB-19764
const addRecipeVariations = recipe => {
  const { id, multiServeVariationId, serves } = recipe;
  const variations = [{ id, serves }];

  if (multiServeVariationId) {
    variations.push({ id: multiServeVariationId, serves: 1 });
  }

  return { ...recipe, variations };
};

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case RESET:
      return {
        ...initialState,
      };

    case FETCH:
      return {
        ...state,
        loading: true,
        message: '',
        params: {
          ...initialState.params,
          ...payload.params,
        },
      };

    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        results: [...(state.append ? state.results : []), ...payload.data],
        pagination: payload.pagination,
      };

    case FETCH_ERROR:
      return {
        ...state,
        loading: false,
        message: 'An error occured performing the search.',
      };

    case UPDATE_APPEND:
      return {
        ...state,
        append: payload,
      };

    case UPDATE_PARAM:
      return {
        ...state,
        params: {
          ...state.params,
          [payload.key]: payload.value,
        },
      };

    case UPDATE_PARAM_ERROR:
      return {
        ...state,
        message: 'An error occured setting a param.',
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/logic/search.js